var map = {
	"./sat_crimea_desk.jpg": 1372,
	"./sat_crimea_desk_dm.jpg": 8008,
	"./sat_crimea_mob.jpg": 1945,
	"./sat_crimea_mob_dm.jpg": 9067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9186;